import React, { useContext } from "react";
import "../Driveanalysis_Coral/GlossaryPage_Coral.css";
import { BsSkipBackwardCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import DashboardMain_Coral from "../DashboardMain_Coral/DashboardMain_Coral";
import AppContext from "../../../store/AppContext";
import { useState } from "react";

function GlossaryPage_Coral() {
  const app_ctx = useContext(AppContext);
  return (
    <>
      <DashboardMain_Coral>
        <body style={{ backgroundColor: "white" }}>
          <h1
            style={{ fontWeight: "bold", marginTop: "6em", fontSize: "2em" }}
            align="center"
          >
            Glossary Page
            <Link
              to="/Driveanalysis_Coral"
              style={{ color: "#32879c", marginLeft: "5%", fontSize: "0.7em" }}
            >
              <BsSkipBackwardCircleFill />
            </Link>
          </h1>
          <table
            className="table table-hover tableglosary"
            style={{ width: "50%", height: "20%" }}
            align="center"
          >
            <thead style={{ backgroundColor: "#32879c", color: "#fff" }}>
              <tr>
                <th scope="col">Sr.No.</th>
                <th scope="col">KPI name</th>
                <th scope="col">Business Logics</th>
                <th scope="col">Backend Formula</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Vehicle Count</td>
                <td>Count of Vehicle Chassis for seleted date range</td>
                <td>Distinct Count (VIN)</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Discharge Cycles</td>
                <td>Count of discharge cycles for seleted date range</td>
                <td>Count (number of discharge cycles)</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Distance Travelled</td>
                <td>Total Distance Covered for selected date range</td>
                <td>Sum (End Odometer - Start Odometer)</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Discharge</td>
                <td>Start Soc minus End Soc</td>
                <td>End SOC - Start SOC</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Median Range</td>
                <td>Median of Range in all discharge cycles of all vehicles</td>
                <td>Median (DistTrav*100/Discharge)</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Median Wh/km</td>
                <td>Median of Wh/km of all discharge cycles of all vehicles</td>
                <td>Median ((Net kWh/DistTrav) *1000)</td>
              </tr>{" "}
              <tr>
                <td>7</td>
                <td>Median discharge duration</td>
                <td>Median of Discharge cycles of all vehicles</td>
                <td>Median (Start Time - End time)</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Percentage Idle Time (%)</td>
                <td>Median of Idle Time %</td>
                <td>
                  Median ((Idel time(Vehicel_Speed=0 & Ignition_Signal=1)/total
                  time)*100)
                </td>
              </tr>
              <tr>
                <td>9</td>
                <td>Median Range (km)</td>
                <td>Median of Range in all discharge cycles</td>
                <td>Median (DistTrav*100/Discharge)</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Median Discharge/Cycle (% SoC)</td>
                <td>Median of discharge Soc for all cycles</td>
                <td>Median (SocStart - SocEnd)</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Median Consumption/Cycle (kWh)</td>
                <td>Median of Net kwh in all discharge cycles</td>
                <td>
                  Median ((BMS_Pack_Ah End - BMS_Pack_Ahstart) * 92.8/1000)
                </td>
              </tr>
              <tr>
                <td>12</td>
                <td>Delta DTE</td>
                <td>
                  Distance_to_Empty (@ End of discharge - @ Start of discharge)
                  for all discharge cycles
                </td>
                <td>Distance_to_Empty (Start - End)</td>
              </tr>
              <tr>
                <td>13</td>
                <td>Error DTE</td>
                <td>
                  Detla DTE minus distance travelled * 100 divided by distance
                  travelled
                </td>
                <td>(Delta DTE - distTrav) *100/distTrav</td>
              </tr>
              <tr>
                <td>14</td>
                <td>Mode utilization</td>
                <td>
                  1. Power Mode = Count of Power_ECO_and_Regen_Mode=1 2. Eco
                  Mode = Count of Power_ECO_and_Regen_Mode=2 3. Regen Mode =
                  Count ofPower_ECO_and_Regen_Mode=3
                </td>
                <td>
                  1. Power Mode = Count(Power_ECO_and_Regen_Mode=1) 2. Eco Mode
                  = Count(Power_ECO_and_Regen_Mode=2) 3. Regen Mode =
                  Count(Power_ECO_and_Regen_Mode=3)
                </td>
              </tr>
            </tbody>
          </table>
        </body>
      </DashboardMain_Coral>
    </>
  );
}

export default GlossaryPage_Coral;
